// @flow

let self;
if (typeof window === 'undefined') {
  self = global;
} else {
  self = window;
}

type Expose = <T>(name: string, module: T) => T;
type PType = { expose: Expose };
const P = {
  ...self.P,
  expose<T>(name: string, module: T): T {
    // eslint-disable-next-line pinterest/no-referencing-p-properties
    P[name] = module;
    return module;
  },
};

self.P = P;

export default (P: PType);
